import { render, staticRenderFns } from "./SectionTickets.vue?vue&type=template&id=060bd45f&"
import script from "./SectionTickets.vue?vue&type=script&lang=js&"
export * from "./SectionTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports